var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToggleOn = function SvgToggleOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6h-11C3.464 6 1 8.688 1 12s2.464 6 5.5 6h11c3.036 0 5.5-2.688 5.5-6s-2.464-6-5.5-6Zm0 9.6c-1.826 0-3.3-1.608-3.3-3.6s1.474-3.6 3.3-3.6c1.826 0 3.3 1.608 3.3 3.6s-1.474 3.6-3.3 3.6Z"
  })));
};
export default SvgToggleOn;